import React from 'react';
import FixedWidthContainer from 'components/consumer/FixedWidthContainer';
import JBImage from 'components/essentials/JBImage';
import featuredInLogos from './featuredInLogos';

const FeaturedIn = () => (
  <div className="bg-gray-light8 pt-[30px] px-0 pb-[50px] print:hidden">
    <FixedWidthContainer>
      <h2 className="text-2xl text-gray mx-auto my-0 pt-0 px-0 pb-[30px] font-bold md:text-center">
        As seen in
      </h2>

      <div className="grid gap-[20px] grid-cols-[repeat(auto-fit,minmax(20%,1fr)_)] md:grid-cols-[repeat(auto-fit,minmax(10%,1fr)_)]">
        {featuredInLogos.map(src => (
          <div
            className="flex items-center justify-center [&_img]:w-20 [&_img]:h-10 [&_img]:object-contain"
            key={src}
          >
            <JBImage className="featured-in__img" src={src} sizes="100vw" />
          </div>
        ))}
      </div>
    </FixedWidthContainer>
  </div>
);

export default FeaturedIn;
